(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-ticker"] && !Shopify.designMode) return;
  try {
    
  class TickerTooltip extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[role="button"]');
      this.tooltip = this.querySelector('.horizontal-ticker__tooltip');
      if (!this.trigger || !this.tooltip) return;
      this.tooltipMoved = false;
      this.trigger.addEventListener('click', this.toggle.bind(this));
      this.trigger.addEventListener('keydown', this.handleTriggerKey.bind(this));
      this.outsideClickHandler = this.handleOutsideClick.bind(this);
      this.escapeHandler = this.handleEscape.bind(this);
      this.repositionHandler = this.close.bind(this);
    }

    connectedCallback() {
      if (this.tooltipMoved || !this.tooltip) return;
      this.tooltipMoved = true;
      document.body.appendChild(this.tooltip);
    }

    isOpen() {
      return this.tooltip.classList.contains('horizontal-ticker__tooltip--visible');
    }

    toggle() {
      this.isOpen() ? this.close() : this.open();
    }

    position() {
      const rect = this.trigger.getBoundingClientRect();
      const margin = 12;
      const gap = 14;
      const tooltipWidth = this.tooltip.offsetWidth;
      const tooltipHeight = this.tooltip.offsetHeight;
      let left = rect.left + rect.width / 2;
      const minLeft = tooltipWidth / 2 + margin;
      const maxLeft = window.innerWidth - tooltipWidth / 2 - margin;
      left = Math.min(Math.max(left, minLeft), maxLeft);
      const top = rect.top - tooltipHeight - gap;
      this.tooltip.style.left = `${left}px`;
      this.tooltip.style.top = `${top}px`;
    }

    open() {
      document.querySelectorAll('ticker-tooltip').forEach((el) => {
        if (el !== this && el.close) el.close();
      });
      this.position();
      this.tooltip.classList.add('horizontal-ticker__tooltip--visible');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.outsideClickHandler);
      document.addEventListener('keyup', this.escapeHandler);
      window.addEventListener('scroll', this.repositionHandler, { passive: true });
      window.addEventListener('resize', this.repositionHandler);
      const tickerContainer = this.closest('.horizontal-ticker__container');
      if (tickerContainer) {
        tickerContainer.classList.add('horizontal-ticker__container--paused');
      }
    }

    close() {
      if (!this.isOpen()) return;
      this.tooltip.classList.remove('horizontal-ticker__tooltip--visible');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.outsideClickHandler);
      document.removeEventListener('keyup', this.escapeHandler);
      window.removeEventListener('scroll', this.repositionHandler);
      window.removeEventListener('resize', this.repositionHandler);
      if (!document.querySelector('.horizontal-ticker__tooltip--visible')) {
        document.querySelectorAll('.horizontal-ticker__container--paused').forEach((el) => {
          el.classList.remove('horizontal-ticker__container--paused');
        });
      }
    }

    handleTriggerKey(event) {
      const key = event.key || '';
      if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
        event.preventDefault();
        this.toggle();
      }
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target) && !this.tooltip.contains(event.target)) {
        this.close();
      }
    }

    handleEscape(event) {
      if ((event.code || '').toUpperCase() === 'ESCAPE') this.close();
    }
  }

  if (!customElements.get('ticker-tooltip')) {
    customElements.define('ticker-tooltip', TickerTooltip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var containers = document.querySelectorAll('.results__rows-container[data-delay]');
    containers.forEach(function (container) {
      var values = container.querySelectorAll('.results__value');
      if (!values.length) return;
      var delay = parseInt(container.dataset.delay, 10) || 0;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setTimeout(function () {
              values.forEach(function (el) {
                el.classList.add('is-visible');
              });
            }, delay);
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });
      observer.observe(container);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
